<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-diving`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45 3v28.5C45 38.917 39.446 45 32.5 45c-5.814 0-10.652-4.261-12.075-10H17a1 1 0 01-1-1v-2a1 1 0 011-1h10a1 1 0 011 1v2a1 1 0 01-1 1h-2.405c1.254 3.53 4.344 6 7.905 6 4.569 0 8.362-4.066 8.496-9.218L41 31.5V3h4zM29 6c6.075 0 11 4.925 11 11s-4.925 11-11 11h-3l-3.106-6.211a1 1 0 00-.335-.382l-.112-.065a1 1 0 00-1.341.447L18 28h-3C8.925 28 4 23.075 4 17S8.925 6 15 6h14zm-14 4h14a7 7 0 110 14h-.528l-2-4a4.999 4.999 0 00-1.678-1.91l-.108-.073-.334-.195-.116-.058A5 5 0 0017.528 20l-2 4H15a7 7 0 110-14z"/></svg>
</template>
<script>

export default {
  name: 'IconDiving',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
